import { createBrowserHistory } from 'history';
import utils from '../utils';

export const customHistory = createBrowserHistory();
const basePath = utils.basePath();

/**
 * Hook que executa o history push
 * @param {string} url
 * @param {object} state
 */
export const useHistoryPush = (url = '', state = {}) => customHistory.push(`${basePath}${url}`, state);

/**
 * Hook que executa o history push para url exata (sem basePath)
 * @param {string} url
 * @param {object} state
 */
export const useHistoryPushExact = (url = '', state = {}) => customHistory.push(`${url}`, state);
